<template>
  <label
    :class="['ui-checkbox', `items-${alignItems}`, { large: large }, { error }]"
  >
    <input
      v-model="model"
      :name="name"
      :value="inputValue"
      class="inp-cbx"
      type="checkbox"
    />
    <span>
      <svg width="12px" height="10px" viewbox="0 0 12 10">
        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
      </svg>
    </span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'UiCheckbox',

  props: {
    modelValue: {
      type: [Boolean, Object, String, Array],
    },
    inputValue: String,
    name: {
      type: String,
      default: 'name',
    },
    error: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    alignItems: {
      type: String,
      default: 'center',
    },
  },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-checkbox {
  display: flex;
  gap: 10px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;

  &.error {
    span {
      border: 1px solid #e21f1f;
    }

    p {
      color: #e21f1f;
    }
  }

  input {
    display: none;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    min-width: 16px;
    min-height: 16px;
    transform: scale(1) translate3d(0, 0, 0);
    border: 2px solid #d1d8dd;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover {
      border: 2px solid #8e9aa4;
      background: #f3f8fc;
    }

    svg {
      position: absolute;
      top: 1px;
      left: 1px;
      fill: none;
      stroke: #ffffffd6;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-dasharray: 13px;
      stroke-dashoffset: 13px;
      transition: all 0.3s ease;
      transition-delay: 0.1s;
      transform: translate3d(0, 0, 0);
    }
  }

  &.large {
    span {
      min-width: 24px;
      min-height: 24px;
      border-radius: 6px;

      svg {
        top: 5px;
        left: 5px;
      }
    }
  }

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 11px;
    color: red;
    transition: 0.3s;
  }

  a {
    color: rgb(250 95 85);
    text-decoration: none;
  }
}

.cbx span {
  display: inline-block;
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}
.cbx span {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: scale(1);
  vertical-align: middle;
  border: 1px solid #9098a9;
  transition: all 0.2s ease;
}
.cbx span:before {
  content: '';
  width: 100%;
  height: 100%;
  background: blue;
  display: block;
  transform: scale(0);
  opacity: 1;
  border-radius: 50%;
}
.inp-cbx:checked + span {
  background: #f36355;
  border-color: #f36355;
  animation: wave-46 0.2s ease;

  &:hover {
    background-color: #d6483d;
    border-color: #d6483d;
  }
}
.inp-cbx:checked + span svg {
  stroke-dashoffset: 0;
}
@keyframes wave-46 {
  50% {
    transform: scale(0.9);
  }
}
::v-deep .checkbox-label {
  color: #6c7885;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
}
.error {
  ::v-deep .checkbox-label {
    color: rgb(250 95 85);
  }
}
</style>
